import Vue from 'vue'
import { eventsMap, numberValuekey } from '@/utils/eventsMap'

const events = {
  HOME_PAGE: {
    PAGE_LOADING: {
      name: '质心灵动量_加载',
      props: ['来源', '是否登录']
    },
    SELECT_CLICK: {
      name: '质心灵动量_筛选_点击',
      props: ['维度', '点击效果', '标签']
    },
    TAB_CLICK: {
      name: '质心灵动量_tab 切换_点击',
      props: ['点击对象']
    }
  },
  USER_ACTION: {
    LOG_OUT_CLICK: '质心灵动量_退出_点击',
    LOGIN_CLICK: '质心灵动量_立即登录_点击'
  },
  COURSE_DETAIL: {
    PAGE_LOADING: {
      name: '长期班_课程详情_加载',
      props: ['是否已报满', '是否已报名', '课程标题', '课程 ID', '课程状态', '课程价格']
    },
    SHARE_CLICK: {
      name: '长期班_课程详情_分享_点击',
      props: ['课程标题', '课程 ID']
    },
    SIGN_UP_CLICK: {
      name: '长期班_课程详情_报名_点击',
      props: ['课程标题', '课程 ID']
    },
    SUBMIT_STUDENT_INFO_CLICK: '长期班_课程详情_提交学生信息_点击',
    INITIATE_A_DELEGATION_CLICK: {
      name: '课程详情_发起拼团_点击',
      props: ['原价', '拼团价', '成团人数', '课程名称', '课程 ID', '已有拼团个数']
    },
    GO_TO_DELEGATION_CLICK: {
      name: '课程详情_去参团_点击',
      props: ['原价', '拼团价', '成团人数', '课程名称', '课程 ID']
    }
  },
  MY_CLASS: {
    GO_LOGIN_CLICK: '质心灵动量_我的班级_去登录_点击',
    COURSE_DETAIL_CLICK: {
      name: '质心灵动量_我的班级_课程信息_点击',
      props: ['订单状态']
    },
    GO_PAY_CLICK: '质心灵动量_我的班级_去支付_点击'
  },
  PAY_PAGES: {
    PAY_PAGE_LOADING: {
      name: '长期班_支付页面_加载',
      props: ['课程标题', '课程 ID', '订单金额']
    },
    GO_TO_PAY_CLICK: {
      name: '长期班_支付页面_去支付_点击',
      props: ['订单金额', '支付方式']
    },
    PAY_SUCCESS_LOADING: {
      name: '长期班_支付成功页_加载',
      props: ['课程标题', '课程 ID']
    }
  },
  GROUP_ACTIVITY: {
    PAY_PAGE_LOADING: {
      name: '拼团页面_加载',
      props: ['课程名称', '拼团状态', '是否登录', '身份', '付款成功进入']
    },
    BUTTON_CLICK: {
      name: '拼团页面_按钮_点击',
      props: ['课程名称', '拼团状态', '是否登录', '按钮内容', '身份']
    }
  },
  LEARING_SITUATION: {
    LEARING_SITUATION_LOADING: {
      name: '学情信息_加载',
      props: ['已报名', '报告状态', '大课标题', '小课标题', '学习进度']
    }
  },
  GET_OFFLINE_UNION_DETAIL: {
    name: '获取已购买的面授课联报详情',
    props: ['goods_id']
  },
  GET_LIVE_UNION_DETAIL: {
    name: '获取已购买的直播课联报详情',
    props: ['goods_id']
  }
}
const newEvents = {
  VISIT_COURSE_DETAIL_PAGE: {
    name: 'VisitCourseDetailPage',
    props: ['Stage', 'CourseSubject', 'Grade', 'CourseContent', 'CourseType', 'CourseSubtype', 'CourseSource', 'CourseID', 'CourseTitle', 'CourseState', 'EnrollmentState', 'RemainingPlaces', 'DiscountActivity', 'CoursePrice', 'GrouponPrice']
  },
  VISIT_COURSE_PURCHASING_LIST: {
    name: 'VisitCoursePurchasingList',
    props: ['CourseType', 'ValidCourseAmount']
  },
  CLICK_ENROLLMENT_BUTTON: {
    name: 'ClickEnrollmentButton',
    props: ['Position', 'ButtonName']
  },
  VISIT_ORDER_CONFIRMING_PAGE: {
    name: 'VisitOrderConfirmingPage',
    props: ['IsNeedAddress', 'IsHaveAvailableCoupon', 'EnrollmentSource', 'TotalPrice', 'ActivityDiscountPrice', 'CourseType']
  },
  COURSE_CARD_CLICK: {
    name: 'CourseCardClick',
    props: ['CourseType', 'CourseSubtype', 'CourseSource', 'CourseID', 'CourseTitle', 'CourseState', 'DiscountActivity']
  },
  MyCourseCardClick: {
    name: 'MyCourseCardClick',
    props: ['CourseType', 'CourseID', 'CourseTitle', 'CourseState', 'Position']
  }
}
function _getPinyin (eventName) {
  if (/\d/.test(eventName.charAt(0))) {
    return '_' + eventsMap[eventName]
  } else if (eventsMap[eventName]) {
    return eventsMap[eventName]
  }
  return eventName
}
Vue.prototype.zhuGeEventTrack = (nodes, propsList, callback) => {
  const props = {}
  const eventName = nodes.name ? nodes.name : nodes

  propsList = propsList || []
  propsList.forEach((prop, index) => {
    props[nodes.props[index]] = prop
  })
  if (window.zhuge) {
    window.zhuge.track(eventName, props, callback)
  }
  if (window.sensors) {
    const includeChinese = eventName.match(/[\u4e00-\u9fa5]/)
    let propsPinyin = {}; let eventNamePinyin = ''
    props.Alias = eventName
    // props.current_url = window.location.href
    if (!includeChinese) {
      propsPinyin = props
      eventNamePinyin = eventName
    } else {
      eventNamePinyin = _getPinyin(eventName)
      Object.keys(props).forEach((key) => {
        const item = props[key]
        const keyPinyin = _getPinyin(key)
        if (numberValuekey.includes(keyPinyin)) {
          propsPinyin[keyPinyin] = Number(item)
        } else if (typeof item !== 'boolean') {
          propsPinyin[keyPinyin] = item + ''
        }
      })
    }
    window.sensors.track(eventNamePinyin, propsPinyin, callback)
  }
}

// Object.assign()
Vue.prototype.zhugeEvents = Object.assign(events, newEvents)
Vue.prototype.zhugeLogin = (userId) => {
  if (window.sensors && window.sensors.login) {
    window.sensors.login(userId)
  }
}
Vue.prototype.setProfile = (props) => {
  const userId = props.userId
  delete props.userId
  if (window.sensors && window.sensors.setProfile) {
    window.sensors.setProfile(props)
    const propsPinyin = {}
    Object.keys(props).forEach((key) => {
      const item = props[key]
      const keyPinyin = _getPinyin(key)
      propsPinyin[keyPinyin] = item
    })
    window.sensors.setProfile(propsPinyin)
  }
  if (window.zhuge && window.zhuge.identify) {
    window.zhuge.identify(userId, props)
  }
}
